import React from 'react';
import { Box, TextField, styled } from '@mui/material';
import theme from '../../themes/theme';
import { useField } from 'formik';

const CustomTextField = styled(TextField)(({ theme }) => ({
  '& .MuiFilledInput-root': {
    backgroundColor: '#FFFFFF',
    border: `1px solid #E4E7EC`,
    borderRadius: '10px',
    padding: '0px 0px 0px',
    // The browser paints the autofill background on the square <input> itself, so
    // without this it bleeds past the rounded corners of this wrapper.
    overflow: 'hidden',
    '&:hover': {
      backgroundColor: '#FFFFFF',
    },
    '&.Mui-focused': {
      backgroundColor: '#FFFFFF',
      borderColor: '#101828',
    },
    '&.Mui-disabled': {
      backgroundColor: '#FFFFFF',
      borderColor: '#E4E7EC',
    },
    '& .MuiFilledInput-input': {
      padding: '15px 16px',
      height: 'auto',
      boxSizing: 'border-box',
    },
    '& .MuiFilledInput-input.Mui-disabled': {
      WebkitTextFillColor: theme.palette.text.primary,
      color: theme.palette.text.primary,
    },
    // Chrome/Safari force their own autofill background via a UA style that only an
    // inset shadow can cover; the long transition keeps it from flashing back in.
    '& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus, & input:-webkit-autofill:active': {
      WebkitBoxShadow: '0 0 0 100px #FFFFFF inset',
      boxShadow: '0 0 0 100px #FFFFFF inset',
      WebkitTextFillColor: theme.palette.text.primary,
      caretColor: theme.palette.text.primary,
      borderRadius: '10px',
      transition: 'background-color 100000s ease-in-out 0s',
    },
  },

  '& .MuiInputBase-input::placeholder': {
    color: theme.palette.customColors.g100,
    opacity: 1,
  },
}));

const CustomInputField = ({
  name,
  label,
  placeholder,
  multiline = false,
  minRows = 1,
  type = 'text',
  startAdornment,
  endAdornment,
  fullWidth = true,
  sx,
  labelStyle = {},
  InputProps = {},
  ...props
}) => {
  const [field, mata] = useField(name);

  const configTextfield = {
    ...field,
    ...props,
    fullWidth,
    autoComplete: 'off',
    variant: 'filled',
    placeholder,
    multiline,
    minRows,
    type,
    InputProps: {
      disableUnderline: true,
      ...InputProps
    },
    "& .MuiFormControl-root": {
      backgroundColor: "rgba(0,0,0,0)"
    },
    sx: { ...sx },
  };

  //   if (mata && mata.touched && mata.error) {
  //     // configTextfield.error = true;
  //     configTextfield.helperText = mata.error;
  //     configTextfield.helperText = <span style={{ color: '#ef5350' }}>{mata.error}</span>;
  // }

  return (
    <Box sx={{ width: fullWidth ? "100%" : sx.width }}>
      {label && (
        <Box
          component="label"
          sx={{
            color: theme.palette.customColors.g500,
            marginBottom: '8px',
            display: 'block',
            fontSize: "0.875rem",
            textTransform: 'none',
            ...labelStyle
          }}
        >
          {label}
        </Box>
      )}
      <CustomTextField
        helperText={mata && mata.error && mata.touched && <span className='validation-message' style={{ color: '#ef5350' }}>{mata.error}</span>}
        {...configTextfield}
        autoComplete='off'
      />
    </Box>
  );
};

export default CustomInputField;
